import _ from "lodash";

export default {
    namespaced: true,
    state: {
        revisions: []
    },
    actions: {
        fetchRevisions({commit, dispatch}, documentId) {
            this.$axios
                .get(process.env.VUE_APP_API_URL + '/api/documents/versions/' + documentId)
                .then(response => {
                    commit('setRevisions', response.data.data);
                })
                .catch(error => {
                    dispatch('setError', error, {root: true})
                })
        }
    },
    mutations: {
        setRevisions(state, revisions) {
            state.revisions = revisions;
        }
    },
    getters: {
        revisions(state) {
            return _.cloneDeep(state.revisions);
        }
    }
}